import { Columns } from "./columns";
import { ReportConfigBase } from "../index";
import { EReportTypes } from "../../routes/report_types";

const InvoiceCreditMemosReportConfig: ReportConfigBase = {
  type: EReportTypes.InvoiceCreditMemos,
  endpoint: "credit-memo",
  filtersBase: [],
  summaryBase: [],
  columnsBase: Columns,
  intro: {
    description:
      "Credit Memos",
    url: "https://help.commonsku.com/knowledge/",
  },
};

export default InvoiceCreditMemosReportConfig;
